import { render, staticRenderFns } from "./ImageCompress.vue?vue&type=template&id=48e28d22&scoped=true"
import script from "./ImageCompress.vue?vue&type=script&lang=js"
export * from "./ImageCompress.vue?vue&type=script&lang=js"
import style0 from "./ImageCompress.vue?vue&type=style&index=0&id=48e28d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e28d22",
  null
  
)

export default component.exports